import {
  EditCompanyOutDto,
  GetOneCompanyOutDto,
  EditCompanyBusinessNameOutDto,
  EditCompanyBigLogoOutDto,
  EditCompanySmallLogoOutDto,
} from '../../types/company.dto'

import { EDIT_COMPANY, EditCompany, RESET_EDIT_COMPANY, ResetEditCompany } from '../types/company/edit'
import { EditCompanyBigLogo, EDIT_COMPANY_BIG_LOGO, ResetEditCompanyBigLogo, RESET_EDIT_COMPANY_BIG_LOGO } from '../types/company/edit-big-logo'
import { EditCompanyBusinessName, EDIT_COMPANY_BUSINESS_NAME, ResetEditCompanyBusinessName, RESET_EDIT_COMPANY_BUSINESS_NAME } from '../types/company/edit-business-name'
import { EditCompanySmallLogo, EDIT_COMPANY_SMALL_LOGO, ResetEditCompanySmallLogo, RESET_EDIT_COMPANY_SMALL_LOGO } from '../types/company/edit-small-logo'
import { GET_ONE_COMPANY, GET_ONE_COMPANY_BY_SLUG, GetOneCompany, RESET_GET_ONE_COMPANY, ResetGetOneCompany } from '../types/company/get-one'

export const getOneCompany = (payload: GetOneCompanyOutDto): GetOneCompany => {
  return { type: GET_ONE_COMPANY, payload }
}

export const getOneCompanyBySlug = (payload: GetOneCompanyOutDto): GetOneCompany => {
  return { type: GET_ONE_COMPANY_BY_SLUG, payload }
}

export const resetGetOneCompany = (): ResetGetOneCompany => {
  return { type: RESET_GET_ONE_COMPANY, payload: null }
}

export const editCompany = (payload: EditCompanyOutDto): EditCompany => {
  return { type: EDIT_COMPANY, payload }
}

export const resetEditCompany = (): ResetEditCompany => {
  return { type: RESET_EDIT_COMPANY, payload: null }
}

export const editCompanyBusinessName = (payload: EditCompanyBusinessNameOutDto): EditCompanyBusinessName => {
  return { type: EDIT_COMPANY_BUSINESS_NAME, payload }
}

export const resetEditCompanyBusinessName = (): ResetEditCompanyBusinessName => {
  return { type: RESET_EDIT_COMPANY_BUSINESS_NAME, payload: null }
}

export const editCompanySmallLogo = (payload: EditCompanySmallLogoOutDto): EditCompanySmallLogo => {
  return { type: EDIT_COMPANY_SMALL_LOGO, payload }
}

export const resetEditCompanySmallLogo = (): ResetEditCompanySmallLogo => {
  return { type: RESET_EDIT_COMPANY_SMALL_LOGO, payload: null }
}

export const editCompanyBigLogo = (payload: EditCompanyBigLogoOutDto): EditCompanyBigLogo => {
  return { type: EDIT_COMPANY_BIG_LOGO, payload }
}

export const resetEditCompanyBigLogo = (): ResetEditCompanyBigLogo => {
  return { type: RESET_EDIT_COMPANY_BIG_LOGO, payload: null }
}